<template>
  <filter-section :id="id">
    <template slot="name">{{ $t('filter.visibilityFilter') }}</template>
    <template slot="content">
      <team-visibility-dropdown
          :initial-value="selectedVisibility"
          @update="(value) => { selectedVisibility = value; filter(); }"
      />
    </template>
  </filter-section>
</template>

<script>
import FilterSection from "./FilterSection";
import {TeamVisibility} from "@/enum";
import TeamVisibilityDropdown from "@/components/organizations/TeamVisibilityDropdown.vue";

export default {
  name: "TagFilter",
  components: {
    FilterSection,
    TeamVisibilityDropdown,
  },
  props: {

    /**
     * An id in order to have a unique identifier when saving filter contents to storage
     * */
    id: {type: String, required: true},
    /**
     * If value changes, the textFilter clears its value
     * */
    clear: {type: Number, default: 0},
    collapsible: {type: Boolean, default: false},
  },
  data() {
    return {
      selectedVisibility: null,
      TeamVisibility,
    };
  },
  computed: {
    getId() {
      return this.$route.name + this.id + 'visibilityFilter';
    }
  },
  watch: {
    clear() {
      this.clearValue();
    },
  },
  beforeMount() {
    let visibilities = window.localStorage.getItem(this.getId);
    if ((visibilities || visibilities === TeamVisibility.PRIVATE) && visibilities !== 'null') {
      this.selectedVisibility = visibilities;
    }
  },
  mounted() {
    this.filter(true);
  },
  methods: {
    clearValue() {
      this.selectedVisibility = null;
      this.filter(true);
    },
    filter(initial = false) {
      const filterParamId = this.getId;
      let params = {};

      if (this.selectedVisibility || this.selectedVisibility === TeamVisibility.PRIVATE) {
        let filterString = 'visibility eq ' + this.selectedVisibility;

        params = {
          add: {
            filter: {
              [filterParamId]: filterString
            },
          }
        };
      } else {
        params = {
          remove: {
            filter: {filterParamId}
          }
        };
      }
      this.$emit('filter', params, initial, 'selectedVisibility');
      window.localStorage.setItem(this.getId, this.selectedVisibility);
    },
  },
}
</script>